@if (screenSize() === 'mobile') {
  <nav class="nav-mobile-left">
    <button mat-icon-button [matMenuTriggerFor]="mobileNavMenu">
      <mat-icon aria-hidden="false" aria-label="Menu" fontIcon="view_headline"></mat-icon>
    </button>
  </nav>

  <mat-menu #mobileNavMenu>
    <button mat-menu-item routerLink="">
      <mat-icon aria-hidden="false" aria-label="Home" fontIcon="home"/>
      Home
    </button>
    <button mat-menu-item routerLink="/users">
      <mat-icon aria-hidden="false" aria-label="Users" fontIcon="person"/>
      Users
    </button>
    <button mat-menu-item routerLink="/modules">
      <mat-icon aria-hidden="false" aria-label="Modules" fontIcon="assignment"/>
      Modules
    </button>
    <button mat-menu-item routerLink="/audit-logs">
      <mat-icon aria-hidden="false" aria-label="Audit Logs" fontIcon="person"/>
      Audit Logs
    </button>
    <button mat-menu-item (click)="router.navigate(['logout'])">
      <mat-icon aria-hidden="false" aria-label="Logout" fontIcon="logout"/>
      Logout
    </button>
  </mat-menu>
} @else {
  <nav class="nav-bar">
    <div class="nav-desktop-left">
      <button class="nav-button" routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <mat-icon aria-hidden="false" aria-label="Home" fontIcon="home"/>
        Home
      </button>
      <button class="nav-button" routerLink="/users" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <mat-icon aria-hidden="false" aria-label="Users" fontIcon="person"/>
        Users
      </button>
      <button class="nav-button" routerLink="/modules" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <mat-icon aria-hidden="false" aria-label="Modules" fontIcon="assignment"/>
        Modules
      </button>
      <button class="nav-button" routerLink="/audit-logs" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <mat-icon aria-hidden="false" aria-label="Audit Logs" fontIcon ="person"/>
        Audit Logs
      </button>
    </div>
    <div class="nav-desktop-right">
      <div class="user-container">
        <p class="welcome-message">Welcome <strong>{{ authService.name() }}</strong></p>
        <button mat-flat-button (click)="authService.logout()">
          <mat-icon aria-hidden="false" aria-label="Logout" fontIcon="logout"/>
          Logout
        </button>
      </div>
    </div>
  </nav>
}
